import { BasicResponse } from "../basicResponse";

export class LinkTokenResponse extends BasicResponse{
    public linkToken?:string;
}